import SpecialTable from './SpecialTable';

export default SpecialTable;
